import { Model, UserModel } from '@descomplica/dex-models';
import { ElapsedTime, getElapsedTime } from '@/helpers/date';
import { UnifiedCommentModel } from '../UnifiedCommentModel';
import { FileModel } from '../FileModel';

export interface DiscussionInfo {
  id: string;
  name: string;
  userId: number;
  channel: string;
  text: string | null;
  createdAt: string;
  attachments?: FileModel[];
}

export class DiscussionModel extends Model {
  id: string;

  name: string;

  text: string | null;

  channelId: string;

  userId: number;

  createdAt: string;

  attachments?: FileModel[];

  constructor(discussion: DiscussionInfo, getters: unknown) {
    super(getters);
    this.id = discussion.id;
    this.name = discussion.name;
    this.userId = discussion.userId;
    this.channelId = discussion.channel;
    this.text = discussion.text;
    this.createdAt = discussion.createdAt;
    this.attachments = discussion.attachments;
  }

  get getElapsedTime(): ElapsedTime {
    return getElapsedTime(this.createdAt);
  }

  get author(): UserModel {
    return this.getters.userById(this.userId);
  }

  get comments(): UnifiedCommentModel[] {
    return this.getters.commentsByDiscussionId(this.id);
  }

  get userProfileAvatar(): string | null {
    const profile = this.getters.profilesByDexId(this.userId);
    return profile?.avatarUrl || null;
  }

  get userProfileName(): string | null {
    const profile = this.getters.profilesByDexId(this.userId);
    return profile?.displayName || null;
  }
}
